var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { PlayerResponsiveContainer } from '../../styles';
import { getPlayerExecutionProps } from './service';
// eslint-disable-next-line @typescript-eslint/no-empty-function
var emptyFunction = function () { };
var Iframe = function (_a) {
    var link = _a.link, sandbox = _a.sandbox, allowProps = _a.allowProps, height = _a.height, css = _a.css, onUpdateLoading = _a.onUpdateLoading;
    return (_jsx("iframe", { width: "100%", src: link, frameBorder: "0", allow: allowProps, allowFullScreen: true, sandbox: sandbox
            ? sandbox
            : 'allow-scripts allow-same-origin allow-presentation allow-popups', height: height, style: css, onLoad: function () { return onUpdateLoading(false); } }, link));
};
export var Player = function (_a) {
    var link = _a.link, category = _a.category, _b = _a.onProviderNotFound, onProviderNotFound = _b === void 0 ? emptyFunction : _b, _c = _a.onError, onError = _c === void 0 ? emptyFunction : _c, _d = _a.onUpdateLoading, onUpdateLoading = _d === void 0 ? emptyFunction : _d;
    var _e = useState(), consolidatedProps = _e[0], setConsolidatedProps = _e[1];
    useEffect(function () {
        var playerProps = safeGetPlayerExecutionProps(link, onError, category);
        if (playerProps) {
            setConsolidatedProps(__assign(__assign({}, playerProps), { onUpdateLoading: onUpdateLoading }));
            onUpdateLoading(true);
        }
        else {
            setConsolidatedProps(undefined);
            onProviderNotFound();
        }
    }, [link, onError, category, onUpdateLoading, onProviderNotFound]);
    return consolidatedProps ? (consolidatedProps.responsive ? (_jsx(Iframe, __assign({}, consolidatedProps), void 0)) : (_jsx(PlayerResponsiveContainer, __assign({ aspect: consolidatedProps.aspect }, { children: _jsx(Iframe, __assign({}, consolidatedProps), void 0) }), void 0))) : null;
};
var safeGetPlayerExecutionProps = function (link, onError, category) {
    try {
        return getPlayerExecutionProps(link, category);
    }
    catch (e) {
        onError();
        return undefined;
    }
};
